import React from 'react';
import Styles from './actualiteCard.module.scss';
import IActualite from 'model/actualite';
import { Card, CardBody, CardTitle, CardText, CardSubtitle } from "reactstrap";
import Picture from 'components/common/picture/picture';

interface IActualiteCardProps {
  actu: IActualite
}

interface IActualiteCardState {
}

class ActualiteCard extends React.Component<IActualiteCardProps, IActualiteCardState>
{
  /**
   *
   */
  constructor(props: IActualiteCardProps) {
    super(props);

    this.state = { actus: [] };
  }

  render() {
    let inline: React.CSSProperties = {};
    return (
      <Card className={Styles.ActualiteCard}>
        <a href={`/#/actualite/${this.props.actu.Id}`} className="c-preview">
          <Picture PictureUrl={encodeURI(this.props.actu.PictureUrl)} RenditionID={2} className="c-preview__img"/>
        </a>
        <CardBody>
          <CardTitle>{this.props.actu.Title}</CardTitle>
          <CardSubtitle>{this.props.actu.PublicationDate.toLocaleDateString()}</CardSubtitle>
          <CardText>{this.props.actu.Chapo}</CardText>
          <a href={`/#/actualite/${this.props.actu.Id}`} className="card-link underlined underlined--thick">Lire la suite</a>
        </CardBody>
      </Card>
    );
  }

}

export default ActualiteCard;
